<template>
  <div class="garage-vacation-info">
    <NuxtImg
      src="/_nuxt/icon-closed.svg"
      alt="Warsztat tymczasowo zamknięty"
      width="40"
      height="40"
    />
    <div class="garage-vacation-info__description">Warsztat tymczasowo zamknięty z powodu urlopu -
      <span> od {{ from }} do {{ to }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs';
import type { GarageVacationJsonldVacationRead } from '~/api/docs/api';
import { getStringDay2 } from '~/helpers/dayjs';


interface IProps {
  garageVacationInfo: GarageVacationJsonldVacationRead;
}

const props = defineProps<IProps>();

// computed
const from = computed(() => {
  const fromDate = dayjs(props.garageVacationInfo.vacation?.from);

  return `${getStringDay2(fromDate.get('day'))}  ${fromDate.format('DD.MM')}`;
});

const to = computed(() => {
  const toDate = dayjs(props.garageVacationInfo.vacation?.to);

  return `${getStringDay2(toDate.get('day'))}  ${toDate.format('DD.MM')}`;
});


</script>

<style lang="scss" scoped>
.garage-vacation-info {
  display: flex;
  align-items: center;
  padding: 12px;
  gap: 10px;
  background-color: #FFF3F3;
  border-radius: 8px;
  margin: 12px 0;

  &__description {
    line-height: 24px;
  }

  span {
    text-decoration: underline;
    font-weight: 500;
  }
}
</style>